import React, { memo, useState, Fragment } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { object, bool } from 'prop-types'

import MenuItem from './Components/MenuItem/MenuItem'

// Primary menu (Create with AI, 3D Models, 3D Printing, Hire a Freelancer,
// Sellers Hub) for the redesigned navigation. Items are data-driven from the
// backend `main_menu_items`; dropdown panels are built in a later phase, so the
// items render as triggers/links only. `isActive` mirrors the hamburger so the
// menu can reveal on mobile (inline from the md breakpoint up).
function Menu({ isActive = false, mainMenuItems = {} }) {
  const [activeDropdown, setActiveDropdown] = useState(null)
  const menuKeys = Object.keys(mainMenuItems)

  function handleToggle(id) {
    setActiveDropdown((current) => (current === id ? null : id))
  }

  if (menuKeys.length === 0) {
    return null
  }

  return (
    <ul className={classnames('unified-nav__menu', isActive && 'unified-nav__menu--open')}>
      {menuKeys.map((key) => {
        const menuItem = mainMenuItems[key]

        return (
          <Fragment key={menuItem.id}>
            {/* `divider` brackets the Sellers Hub item with a leading rule. */}
            {menuItem.divider && <li className="unified-nav__menu-divider" aria-hidden="true" />}
            <MenuItem
              menuItem={menuItem}
              isOpen={activeDropdown === menuItem.id}
              onToggle={handleToggle}
            />
          </Fragment>
        )
      })}
      {/* Trailing rule separates the menu from the user actions (inline layout only). */}
      <li className="unified-nav__menu-divider" aria-hidden="true" />
    </ul>
  )
}

Menu.propTypes = {
  isActive: bool,
  mainMenuItems: object,
}

export default memo(Menu)
